
module.exports = function getResource(label, vars = []) {
    let resources = {
        noResults1: 'Sorry, there are no products that match your filter choices.',
        noResults2: 'Try changing some of your filters to see product results.'
    };
    return resources[label];
};
